import type { PollSettings, VotesData } from '../../types';
import { unvoteLocal } from './unvote-local';
import { voteLocal } from './vote-local';

type LocalChangeVoteProps = {
  unvoteId: string;
  voteId: string;
  answers: PollSettings['answers'];
  data: VotesData | undefined;
};

export function changeVoteLocal({
  unvoteId,
  voteId,
  answers,
  data
}: LocalChangeVoteProps) {
  const newVotes = unvoteLocal({
    id: unvoteId,
    answers,
    data
  });

  return voteLocal({
    id: voteId,
    answers,
    data: newVotes
  });
}
